export default __webpack_public_path__ + "static/media/sidebar_graph.92cc4b81.png";